module.exports = __webpack_public_path__ + "img/astro6.f3d70486.jpg";